<template>
    <section class="module-banner-homepage">
        <div class="module-banner-homepage__wrapper" v-if="moduleData">
            <h2 class="module-banner-homepage__title" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out-back">{{ moduleData.title }}</h2>
            <p class="module-banner-homepage__subtitle">{{ moduleData.lead }}</p>
                <a 
                :href="moduleData.showMoreUrl" 
                class="module-banner-homepage__btn" 
                data-aos="zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="600"
                data-aos-easing="ease-out-back"
            >
                <span>{{ moduleData.showMoreTitle }}</span>
            </a>

            <div class="module-banner-homepage__icons">
                <a href="https://play.google.com/store/apps/details?id=pl.tvp.krainaAbc" target="_blank"
                    class="module-banner-homepage__icon"                     
                    data-aos="fade-in" 
                    data-aos-duration="1000"
                    data-aos-delay="1000"
                    data-aos-easing="ease-out-back"
                >
                    <img src="/templates/xhtml/krainaabc/src/assets/images/google_play.png" alt=""/>
                </a>
                <a href="https://apps.apple.com/pl/app/kraina-abc/id1618917144" target="_blank"
                    class="module-banner-homepage__icon"                     
                    data-aos="zoom-in" 
                    data-aos-duration="1000"
                    data-aos-delay="1000"
                    data-aos-easing="ease-out-back"
                >
                    <img src="/templates/xhtml/krainaabc/src/assets/images/app_store.png" alt=""/>
                </a>   
                <a href="https://appgallery.cloud.huawei.com/marketshare/app/C107151661" target="_blank"
                    class="module-banner-homepage__icon"                     
                    data-aos="zoom-in" 
                    data-aos-duration="1000"
                    data-aos-delay="1000"
                    data-aos-easing="ease-out-back"
                >
                    <img src="/templates/xhtml/krainaabc/src/assets/images/app_gallery.png" alt=""/>
                </a>         
            </div>
        </div>

        <video
            data-aos="fade-in" 
            data-aos-duration="500"
            playsinline autoplay muted loop
            class="module-banner-homepage__video"
            src="https://s.tvp.pl/files/portale-v4/krainaabc/video/driver.mp4"
            type="video/mp4"
            :poster="getVideoPoster(moduleData.image)"
        >
        </video>

    </section>
</template>

<script>
import { parseImageUrl } from '../../mixins/useParseImage';

    export default {
        name: "ModuleBannerHomepage",
        props: {
            module: {
                type: Object,
                required: true,
            }
        },
        mixins: [parseImageUrl],
        computed: {
            moduleData() {
                if(this.module && this.module.items) {
                    return {
                        title: this.module.items[0].title,
                        lead: this.module.items[0].lead,
                        image: this.module.items[0].image,
                        showMoreUrl: this.module.show_more.url,
                        showMoreTitle: this.module.show_more.title
                    }
                }
                return null;
            }
        },
        methods: {
            getVideoPoster(img) {
                let url = '';
                if (img && img.url) {
                    url = parseImageUrl(img.url,1920,500);
                }
                return url;
            },
        },
    }
</script>